import React, { useEffect, useRef, useState } from "react";
import BpmnModeler from "bpmn-js/lib/Modeler";
import useSelectorId from "../../../utilities/hooks/useSelectorId";

import "../../../../node_modules/bpmn-js/dist/assets/diagram-js.css";
import "../../../../node_modules/bpmn-js/dist/assets/bpmn-js.css";
import "../../../../node_modules/bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";
import "./BPMNDemo.css";
import { ECLDropDown, ECLThemeImage } from "../../../eclComponents";
import { translate } from "../../../utilities/Translate";
import ECLDialog from "../../../eclComponents/Widgets/ECLDialog/ECLDialog";

//May well be handy later
// function centerAndFitViewport(modeler) {
//     const canvas = modeler.get("canvas");
//     const { inner } = canvas.viewbox();
//     const center = {
//         x: inner.x + inner.width / 2,
//         y: inner.y + inner.height / 2
//     };
//     canvas.zoom("fit-viewport", center);
// }

function fileDownload(blob, name, ext) {
   const link = document.createElement("a");
   link.href = URL.createObjectURL(blob);
   link.download = `${name}.${ext}`;
   link.click();
   link.remove();
}

export default function BPMNDemo() {
   const [zoom, setZoom] = useState(1);
   const BPMNContainer = useRef(null);
   //Preview stuff on hold, I still haven't seen how Desktop expects to handle the AI stuff (where I assume the preview would come in handy)
   // const previewContainer = useRef(null)
   // const previewViewerRef = useRef(null)
   const ModelerRef = useRef(null);
   const instanceID = useSelectorId();

   useEffect(() => {
      ModelerRef.current = new BpmnModeler({
         container: BPMNContainer.current,
      });
      ModelerRef.current.createDiagram();

      // previewViewerRef.current = new BpmnViewer({ container: previewContainer.current })
      // previewViewerRef.current.importXML(diagram).then(() => centerAndFitViewport(previewViewerRef.current))
   }, []);

   useEffect(() => {
      ModelerRef.current.get("canvas").zoom(Number(zoom));
   }, [zoom]);

   return (
      <div className="bpmn-widget">
         <div
            className="bpmn-container"
            ref={BPMNContainer}
            id={"bpmn" + instanceID}
            tabIndex={0}
         ></div>
         <ECLDropDown
            trigger={<ECLThemeImage fontAwesome="bars" />}
            containerId={"bpmn" + instanceID}
            menuWidth={300}
         >
            <button
               onClick={(e) => {
                  e.preventDefault();
                  ModelerRef.current &&
                     ModelerRef.current
                        .saveXML({ format: true })
                        .then((res) => {
                           const newFile = new Blob([res.xml], {
                              type: "application/xml",
                           });
                           fileDownload(newFile, "bpmn_draft", "bpmn");
                        });
               }}
            >
               Export XML
            </button>
            <button
               onClick={(e) => {
                  e.preventDefault();
                  ModelerRef.current &&
                     ModelerRef.current
                        .saveSVG({ format: true })
                        .then((res) => {
                           const newFile = new Blob([res.svg], {
                              type: "image/svg+xml",
                           });
                           fileDownload(newFile, "bpmn_draft_svg", "svg");
                        });
               }}
            >
               Export SVG
            </button>
            <ECLDialog
               triggerText="Import BPMN File"
               title="Import BPMN File"
               customButtons={{}}
            >
               <label htmlFor="bpmn-import-input">
                  Choose a BPMN file to render
               </label>
               <input
                  id="bpmn-import-input"
                  type="file"
                  accept={".bpmn,.xml"}
                  onChange={(e) => {
                     const file = e.target.files[0];
                     if (file) {
                        const reader = new FileReader();
                        reader.onload = function (e) {
                           const parser = new DOMParser();
                           const xmlDoc = parser.parseFromString(
                              e.target.result,
                              "application/xml",
                           );
                           ModelerRef.current.importXML(
                              new XMLSerializer().serializeToString(xmlDoc),
                           );
                        };
                        reader.readAsText(file);
                     }
                  }}
               ></input>
            </ECLDialog>
         </ECLDropDown>
         <div className="bpmn-zoom-control-widget">
            <button
               onClick={(e) => {
                  e.preventDefault();
                  setZoom((z) => (z - 0.25 > 0.1 ? z - 0.25 : 0.1));
               }}
            >
               <ECLThemeImage fontAwesome="minus" alt={translate("Zoom out")} />
            </button>
            <input
               type="range"
               value={zoom}
               onChange={(e) => setZoom(e.target.value)}
               min={0.1}
               max={5}
               step={0.1}
            />
            <button
               onClick={(e) => {
                  e.preventDefault();
                  setZoom((z) => (z + 0.25 < 5 ? z + 0.25 : 5));
               }}
            >
               <ECLThemeImage fontAwesome="plus" alt={translate("Zoom in")} />
            </button>
            <button
               onClick={(e) => {
                  e.preventDefault();
                  ModelerRef.current.get("canvas").zoom("fit-viewport");
               }}
            >
               <ECLThemeImage fontAwesome="up-right-and-down-left-from-center" />
            </button>
         </div>
      </div>
   );
}
